import 'angular:locale/data:ja';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "ja";
